import React from 'react';
import { componentService } from 'js/services/component.service';

export const DynamicRegistration = React.lazy(() => import(/* webpackChunkName: "dynamic-registration" */ './DynamicRegistration'));

componentService.registerPageComponents({ 'dynamic-registration': DynamicRegistration });

